import getCurrentLanguage from "./getCurrentLanguage";

const __ = (field: string, fallback: string = "No content found"): string => {
	// Check for localized vars.
	const localizedContent = (window as any).midtownMembershipsContent as Record<
		string,
		any
	>;

	let language = getCurrentLanguage();

	// Make english the default language.
	if (localizedContent && !(language in localizedContent)) {
		language = "en";
	}

	const translatedField = localizedContent?.[language]?.[field];

	return translatedField ?? fallback;
};

export default __;
